{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Voir toutes les options",
  "Spoiler_Reveal_Tooltip": "Cliquez pour afficher",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweetez ceci",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "L'élément est réduit",
  "Spoiler_Reveal_Video_CTA": "Révéler la vidéo",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Agrandir l'image",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Voir tous les résultats",
  "Spoiler_Reveal_Image_Placeholder": "Cette image contient un spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Curseur",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Vous pouvez voter pour plus d'une réponse.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Afficher plus de commandes audio",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Fermer",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Chargement {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Avatar de l'utilisateur",
  "Preview_ReadMore_Label": "Lire plus",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volume",
  "Spoiler_Reveal_Gallery_Placeholder": "Cette galerie contient un spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Réserver",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Désactiver la mise en sourdine",
  "Spoiler_Reveal_Gallery_CTA": "Révéler la galerie",
  "Poll_Viewer_ShowLess_CTA": "Afficher moins",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Mettre en sourdine",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+ {{anonNumber}} anonymes",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Suivre",
  "VerticalEmbed_Products_Button": "Acheter",
  "Poll_Viewer_Toast_Error_ServerDown": "Impossible de se connecter au serveur Veuillez réessayer plus tard.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} personnes ont voté pour cette réponse",
  "Poll_Viewer_VoteCount": "{{number}} votes",
  "VerticalEmbed_Events_Button": "S'inscrire",
  "Spoiler_Reveal_Image_CTA": "Révéler l'image",
  "Poll_Viewer_Toast_Error_Connection": "Pas de connexion internet. Vérifiez votre connexion.",
  "Poll_Viewer_Visibility_Owner_Footer": "Vous seul pouvez voir les résultats.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} personnes ont voté pour cette réponse",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "L'élément est agrandi",
  "Audio_Plugin_Cover_Alt": "Couverture de l'audio",
  "Spoiler_Reveal_Video_Placeholder": "Cette vidéo contient un spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Voir le post entier",
  "UploadFile_Viewer_Download": "Télécharger {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} h",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
